import { red } from "@material-ui/core/colors"
import { createTheme } from "@material-ui/core/styles"

// Create a theme instance.
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 350,
      sm: 768,
      md: 900,
      lg: 1600,
      xl: 1920
    }
  },
  palette: {
    primary: {
      main: "#3364AF",
    },
    secondary: {
      main: "#FDB738",
    },
    error: {
      main: red.A400,
    },
    background: {
      default: "#FFFFFF",
    },
  },
  label: {
    backgroundColor: "white"

  },
  typography: {
    fontFamily: 'Prompt, Roboto,   "Helvetica Neue", sans-serif',
    button: {
      textTransform: "none",
    },
  },

})

export default theme
